import React from 'react'
import {Button, Col, Row, Tag} from "antd";
import {PlusCircleFilled} from "@ant-design/icons";

export default function CropSearchResults({searchResults, onSelect, onCropFound, showOwnCrops}) {

    function handleClick(crop, source) {
        if (source === 'user' && onSelect) {
            onSelect(crop)
        } else if (onCropFound) {
            onCropFound(crop)
        }
    }

    const rows = []

    if (searchResults.user && showOwnCrops) {
        searchResults.user.forEach((crop, i) => {
            rows.push({crop, source: 'user', key: 'user-' + i})
        })
    }

    if (searchResults.product_database) {
        searchResults.product_database.forEach((crop, i) => {
            rows.push({crop, source: 'product_database', key: 'product-' + i})
        })
    }

    return (
        <div>
            {rows.map(({crop, source, key}) => (
                <Row key={key} style={{marginBottom: '18px'}}>
                    <Col span={4}>
                        <img src={crop.image} alt={crop.name} style={{maxWidth: '48px', maxHeight: '48px'}}/>
                    </Col>
                    <Col span={15}>
                        <h4>{crop.name}{crop.variety ? ` - ${crop.variety}` : ''}</h4>
                        {source === 'user' && <Tag color="green">Uit mijn gewassen</Tag>}
                        {(crop.supplier_name || crop.supplier) ? <small>{crop.supplier_name || crop.supplier}</small> : null}
                    </Col>
                    <Col span={5} className={"text-right"}>
                        <Button onClick={() => handleClick(crop, source)}>
                            <PlusCircleFilled/>
                        </Button>
                    </Col>
                </Row>
            ))}
        </div>
    )
}
